export default "__VITE_ASSET__B$U$eT6H__"